import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,textarea,p,blockquote,th,td,input,select,button{margin:0;padding:0;}
fieldset,img{border:0 none;}
dl,ul,ol,menu,li{list-style:none;}
blockquote,q{quotes:none;}
blockquote:before,blockquote:after,q:before,q:after{content:'';content:none;}
input,select,textarea,button{border-radius:0;vertical-align:middle;}
button{border:0 none;background-color:transparent;cursor:pointer;}
body,th,td,input,select,textarea,button{font-size:14px;line-height:1.5;font-family:'Noto Sans KR', AppleSDGothicNeo-Regular,'MalgunGothic','맑은고딕',dotum,'돋움',sans-serif;color:#262626;}
a{color:#222;text-decoration:none;} 
a:active{background-color:transparent;}
address,caption,cite,code,dfn,em,var{font-style:normal;font-weight:normal;}
*{box-sizing:border-box;color:inherit;}  
`;
export default GlobalStyle;
